import { Label, TextField } from "@fluentui/react";

interface StringFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
  description?: string;
}

export default function StringField({ label, required, value, onChange, errorMessage, description }: StringFieldProps) {
  return (
    <>
      <TextField
        label={label}
        required={required}
        defaultValue={value}
        onChange={(_e, val) => onChange(val ?? "")}
        errorMessage={errorMessage}
        ariaLabel={label}
      />
      {description && (
        <Label disabled style={{ fontSize: "12px" }}>
          {description}
        </Label>
      )}
    </>
  );
}
